import styled from "styled-components";

import { media } from "../../styles/media";

export const TiketDetailsStyles = styled.div`
  height: 100%;

  .tiketDetailsCard {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: ${({ theme }) => theme.colors.semantic.container.white};
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
    border-radius: ${({ theme }) => theme.radius[16]};
    overflow: hidden;
    font-family: ${({ theme }) => theme.typography.fontFamily};
  }

  .sd-header {
    flex: 0 0 auto;
    height: 56px;
    padding: 0 ${({ theme }) => theme.spacing[20]};
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid
      ${({ theme }) => theme.colors.semantic.separator};
  }

  .sd-header__title {
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-size: ${({ theme }) => theme.typography.title.t1.size};
    line-height: ${({ theme }) => theme.typography.title.t1.lineHeight};
    font-weight: ${({ theme }) => theme.typography.title.t1.weight};
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    margin: 0;
    display: inline-flex;
    align-items: baseline;
    gap: ${({ theme }) => theme.spacing[8]};
  }

  .sd-header__id {
    font-size: ${({ theme }) => theme.typography.body.b3.size};
    line-height: ${({ theme }) => theme.typography.body.b3.lineHeight};
    font-weight: ${({ theme }) => theme.typography.body.b3.weight};
    color: ${({ theme }) => theme.colors.semantic.text.weak};
  }

  .sd-header__close {
    width: 32px;
    height: 32px;
    border-radius: ${({ theme }) => theme.radius.rounded};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: 1px solid ${({ theme }) => theme.colors.semantic.separator};
    background: ${({ theme }) => theme.colors.semantic.container.white};

    svg > circle {
      display: none;
    }

    &:hover {
      background: ${({ theme }) => theme.colors.semantic.container.gray};
    }
  }

  .sd-messages-bar {
    flex: 0 0 auto;
    position: relative;
    z-index: 3;
    padding: ${({ theme }) => theme.spacing[16]}
      ${({ theme }) => theme.spacing[20]};
    padding-bottom: 0;
    background: ${({ theme }) => theme.colors.semantic.container.white};
    box-shadow: 0 -6px 24px rgba(16, 24, 40, 0.08);
  }

  .messagesButton {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${({ theme }) => theme.spacing[8]};
    padding: ${({ theme }) => theme.spacing[12]}
      ${({ theme }) => theme.spacing[12]};
    font-weight: ${({ theme }) => theme.typography.title.t2.weight};
    font-size: ${({ theme }) => theme.typography.title.t2.size};
    line-height: ${({ theme }) => theme.typography.title.t2.lineHeight};
  }

  .notificationCounter {
    width: 18px;
    height: 18px;
  }

  .sd-body {
    flex: 1 1 auto;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
  }

  .sd-block {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[16]};
    padding: ${({ theme }) => theme.spacing[20]};
    border-bottom: 1px solid
      ${({ theme }) => theme.colors.semantic.separator};

    &:last-child {
      border-bottom: none;
    }
  }

  .sd-branch-info {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[4]};
  }

  .sd-branch-info__name {
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-size: ${({ theme }) => theme.typography.title.t1.size};
    line-height: ${({ theme }) => theme.typography.title.t1.lineHeight};
    font-weight: ${({ theme }) => theme.typography.title.t1.weight};
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    overflow-wrap: anywhere;
  }

  .sd-branch-info__address {
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-size: ${({ theme }) => theme.typography.body.b3.size};
    line-height: ${({ theme }) => theme.typography.body.b3.lineHeight};
    font-weight: ${({ theme }) => theme.typography.body.b3.weight};
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    overflow-wrap: anywhere;
  }

  .sd-map-card {
    position: relative;
    height: 160px;
    border-radius: ${({ theme }) => theme.radius[12]};
    overflow: hidden;
    border: 1px solid ${({ theme }) => theme.colors.semantic.separator};

    .copyLocation {
      position: absolute;
      top: ${({ theme }) => theme.spacing[8]};
      right: ${({ theme }) => theme.spacing[8]};
      z-index: 2;
      padding: ${({ theme }) => theme.spacing[4]}
        ${({ theme }) => theme.spacing[12]};
      background: ${({ theme }) => theme.colors.semantic.container.white};
      border: 1px solid
        ${({ theme }) => theme.colors.semantic.outline.default};
      border-radius: ${({ theme }) => theme.radius[8]};
      font-family: ${({ theme }) => theme.typography.fontFamily};
      font-size: ${({ theme }) => theme.typography.title.t3.size};
      font-weight: ${({ theme }) => theme.typography.title.t3.weight};
      line-height: ${({ theme }) => theme.typography.title.t3.lineHeight};
      color: ${({ theme }) => theme.colors.semantic.text.strong};
    }
  }

  .sd-grid-2 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${({ theme }) => theme.spacing[16]};
    ${media.maxMobile`grid-template-columns: 1fr;`}
  }

  .sd-field {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[4]};
    min-width: 0;

    .label {
      font-size: ${({ theme }) => theme.typography.label.size};
      line-height: ${({ theme }) => theme.typography.label.lineHeight};
      font-weight: ${({ theme }) => theme.typography.label.weight};
      color: ${({ theme }) => theme.colors.semantic.text.weak};
    }

    .value {
      font-size: ${({ theme }) => theme.typography.title.t2.size};
      line-height: ${({ theme }) => theme.typography.title.t2.lineHeight};
      font-weight: ${({ theme }) => theme.typography.title.t2.weight};
      color: ${({ theme }) => theme.colors.semantic.text.strong};
      overflow-wrap: anywhere;
    }

    .value--capitalize {
      text-transform: capitalize;
    }

    .value--nowrap {
      white-space: nowrap;
    }

    .meta {
      font-size: ${({ theme }) => theme.typography.body.b3.size};
      line-height: ${({ theme }) => theme.typography.body.b3.lineHeight};
      font-weight: ${({ theme }) => theme.typography.body.b3.weight};
      color: ${({ theme }) => theme.colors.semantic.text.weak};
      overflow-wrap: anywhere;
    }

    .sd-link-btn {
      align-self: flex-start;
      background: none;
      border: none;
      padding: 0;
      margin-top: ${({ theme }) => theme.spacing[4]};
      font-family: ${({ theme }) => theme.typography.fontFamily};
      font-size: ${({ theme }) => theme.typography.link.size};
      font-weight: ${({ theme }) => theme.typography.title.t3.weight};
      line-height: ${({ theme }) => theme.typography.link.lineHeight};
      color: ${({ theme }) => theme.colors.semantic.text.link};
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .sd-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${({ theme }) => theme.spacing[12]};
  }

  .sd-row__values {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }

  .sd-estimate-btn {
    flex: 0 0 auto;
  }

  .sd-card {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[4]};
    padding: ${({ theme }) => theme.spacing[16]};
    border: 1px solid ${({ theme }) => theme.colors.semantic.separator};
    border-radius: ${({ theme }) => theme.radius[12]};

    .card-label {
      font-size: ${({ theme }) => theme.typography.label.size};
      line-height: ${({ theme }) => theme.typography.label.lineHeight};
      font-weight: ${({ theme }) => theme.typography.label.weight};
      color: ${({ theme }) => theme.colors.semantic.text.weak};
    }

    .card-title {
      font-size: ${({ theme }) => theme.typography.title.t2.size};
      line-height: ${({ theme }) => theme.typography.title.t2.lineHeight};
      font-weight: ${({ theme }) => theme.typography.title.t2.weight};
      color: ${({ theme }) => theme.colors.semantic.text.strong};
      overflow-wrap: anywhere;
    }

    .card-meta {
      font-size: ${({ theme }) => theme.typography.body.b3.size};
      line-height: ${({ theme }) => theme.typography.body.b3.lineHeight};
      font-weight: ${({ theme }) => theme.typography.body.b3.weight};
      color: ${({ theme }) => theme.colors.semantic.text.weak};
      overflow-wrap: anywhere;
    }
  }

  .sd-section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${({ theme }) => theme.spacing[12]};

    .section-title {
      font-size: ${({ theme }) => theme.typography.label.size};
      line-height: ${({ theme }) => theme.typography.label.lineHeight};
      font-weight: ${({ theme }) => theme.typography.label.weight};
      color: ${({ theme }) => theme.colors.semantic.text.weak};
    }
  }

  .sd-workers-list {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[8]};
  }

  .sd-workers-empty {
    font-size: ${({ theme }) => theme.typography.body.b3.size};
    line-height: ${({ theme }) => theme.typography.body.b3.lineHeight};
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    padding: ${({ theme }) => theme.spacing[12]};
    text-align: center;
    border: 1px dashed ${({ theme }) => theme.colors.semantic.separator};
    border-radius: ${({ theme }) => theme.radius[8]};
  }

  .sd-comments-list {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[8]};
  }

  .sd-create-comment {
    margin-top: ${({ theme }) => theme.spacing[8]};
  }

  .sd-inline-btn {
    align-self: flex-start;
    padding: 4px 10px;
    font-size: ${({ theme }) => theme.typography.title.t3.size};
    line-height: ${({ theme }) => theme.typography.title.t3.lineHeight};
    border-radius: ${({ theme }) => theme.radius[8]};
  }
`;
